import { useState } from "react";

import { useCountriesQuery } from "@sso/apis/country";
import FormikTypeahead, { AutoCompleteOption } from "@sso/components/Formik/FormikTypeahead";
import { Country } from "@sso/types";
import { RawInput } from "@sso/ui/RawInput";

interface CountryTypeaheadProps {
  name: string;
  clear: () => void;
  handleChange?: (country: Country) => void;
}

const CountryTypeahead = ({ name, clear, handleChange }: CountryTypeaheadProps) => {
  const { data: countries, isSuccess } = useCountriesQuery();
  const [countrySearchTerm, setCountrySearchTerm] = useState<string>("");

  const countryOptions =
    (countries?.map(x => ({
      key: x.id,
      value: x.id,
      label: x.name,
      elementLabel: (
        <div style={{ display: "flex", gap: "1rem" }}>
          <img src={`https://flagcdn.com/24x18/${x.countryCode?.toLowerCase()}.png`} />
          <div>{x.name}</div>
        </div>
      ),
    })) as AutoCompleteOption[]) || [];

  const onClear = () => {
    setCountrySearchTerm("");
    clear();
  };

  const onChange = (value: string | number) => {
    const selectedCountry = countries?.find(x => x.id === value);
    if (!selectedCountry) {
      return;
    }
    handleChange && handleChange(selectedCountry);
  };

  return isSuccess && countries ? (
    <FormikTypeahead
      items={countryOptions.filter(x => x.label.toLowerCase().includes(countrySearchTerm.toLowerCase()))}
      label="Country"
      onSearch={term => setCountrySearchTerm(term)}
      clear={() => onClear()}
      name={name}
      handleChange={onChange}
    />
  ) : (
    <RawInput placeholder="Country" />
  );
};

export default CountryTypeahead;
